/**
 * Возвращает текущую дату/время по московскому часовому поясу (UTC+3).
 * Логика идентична moscowNow() из мобильного приложения (Tennis-Mobile-F).
 */
export function moscowNow(): Date {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utc + 3 * 60 * 60 * 1000);
}
